module.exports = __webpack_public_path__ + "static/media/class (15).5a040ce4.webp";